import { useRef, useState } from 'react';
import { flushSync } from 'react-dom';

/**
 * Field errors stay hidden until the first save attempt, then follow the fields
 * as they change. A refused attempt moves focus to the first field in error.
 */
export function useSaveAttempt() {
  const fieldsRef = useRef<HTMLDivElement>(null);
  const [hasAttempted, setHasAttempted] = useState(false);

  return {
    fieldsRef,
    hasAttempted,
    refuse: () => {
      // Paint the errors before moving focus, so the first one is findable.
      flushSync(() => {
        setHasAttempted(true);
      });
      fieldsRef.current?.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus();
    },
    reset: () => setHasAttempted(false),
  };
}
